import {useState} from "react";
import BatterIconLogo from "./BatterIconLogo";
import "../styles/getPasswordResetLink.css"

function GetPasswordResetLink() {
    const [email, setEmail] = useState('')
    const [emailSent, setEmailSent] = useState(false)
    const [error, setError] = useState("")

    function handleEmailChange(e) {
        setEmail(e.target.value)
    }

    function handleEmailSubmit(e) {
        e.preventDefault()

        fetch('/api_password_resets', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email
            })
        })
        .then(res => res.json())
        .then(data => {
            //console.log('data from get password reset link', data)
            if (!data.error) {
                setEmailSent(true)
            }
            else (
                setError(data.error)
            )
        })
    }

    return (
        <div className="getPWResetLinkContainer">
            {/* <BatterIconLogo logoID={"pw-reset-logo"} /> */}
            <div className="getPWResetLinkElements">
                <h2>Forgot Password?</h2>
                <form onSubmit={handleEmailSubmit}>
                    <label>Email:</label>
                    <input id="email" type="text" value={email} onChange={handleEmailChange} placeholder="Enter email address" />
                    <button type="submit">Send Email</button>
                </form>
                {emailSent && (<h2>Password Instructions Sent to Your Email.</h2>)}
                {error && (<p style={{color: "red", fontSize: "1rem"}} >{error}</p>)}
            </div>
        </div>
    )
}

export default GetPasswordResetLink